import React, { useEffect, useState } from "react";
import "./Body.css";
import Testimonials from "../Testimonial/Testimonials";
import homeimage from "./homeCar img.png";
import innova from "./innova.png";
import { Link } from "react-router-dom";

const Body = () => {
  const services = [
    { icon: "🚖", text: "24/7 City Rides" },
    { icon: "✈️", text: "Airport Transfers" },
    { icon: "⏱️", text: "Hourly Rentals" },
    { icon: "🏢", text: "Corporate Rides" },
    { icon: "🎉", text: "Event Transportation" },
    { icon: "👨‍👩‍👧‍👦", text: "Family Rides" },
    { icon: "💼", text: "Business Travel" },
    { icon: "🏨", text: "Hotel Pickups" },
  ];

  const [activeFeature, setActiveFeature] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % 4);
    }, 3000);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      clearInterval(interval);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [hoveredRow, setHoveredRow] = useState(null);

  const fareData = [
    {
      type: "Indica, Swift or similar",
      seats: "4 Seats",
      // baggage: "1 Bag — AC",
      baseFare: "₹12/KM",
      totalFare: "₹14/KM + 10 (Taxes & Charges)",
      kmIncluded: "80 kms included",
      extraFare: "Extra fare ₹16.5/km after 80 kms",
    },
    {
      type: "Ertiga or similar SUV",
      seats: "6 Seats",
      // baggage: "1 Bag — AC",
      baseFare: "₹15/KM",
      totalFare: "₹18/KM + 10 (Taxes & Charges)",
      kmIncluded: "80 kms included",
      extraFare: "Extra fare ₹16.5/km after 80 kms",
    },
    {
      type: "Innova or similar",
      seats: "6 Seats",
      // baggage: "1 Bag — AC",
      baseFare: "₹17/KM",
      totalFare: "₹19/KM + 10 (Taxes & Charges)",
      kmIncluded: "80 kms included",
      extraFare: "Extra fare ₹16.5/km after 80 kms",
    },
    {
      type: "Innova Crystal or similar",
      seats: "4 Seats",
      // baggage: "1 Bag — AC",
      baseFare: "₹20/KM",
      totalFare: "₹25/KM + 10 (Taxes & Charges)",
      kmIncluded: "80 kms included",
      extraFare: "Extra fare ₹16.5/km after 80 kms",
    },
  ];

  const [hoveredRowtable, setHoveredRowtable] = useState(null);

  const fareDatatable = [
    {
      name: "Indigo C5",
      fixed: "Rs. 1500",
      rate1: "Rs. 10/Km",
      rate2: "Rs. 9.5/Km",
    },
    {
      name: "Maruti Swift Dzire",
      fixed: "Rs. 2150",
      rate1: "Rs. 13/Km",
      rate2: "Rs. 10/Km",
    },
    {
      name: "Tavera",
      fixed: "Rs. 2100",
      rate1: "Rs. 13.5/Km",
      rate2: "Rs. 13.5/Km",
    },
    {
      name: "Innova",
      fixed: "Rs. 2970",
      rate1: "Rs. 17/Km",
      rate2: "Rs. 16/Km",
    },
    {
      name: "Xylo",
      fixed: "Rs. 2200",
      rate1: "Rs. 14/Km",
      rate2: "Rs. 13.5/Km",
    },
    {
      name: "Toyota Crysta",
      fixed: "Rs. 3525",
      rate1: "Rs. 19/Km",
      rate2: "Rs. 18.5/Km",
    },
    {
      name: "Maruti Ertiga",
      fixed: "Rs. 2850",
      rate1: "Rs. 16/Km",
      rate2: "Rs. 12/Km",
    },
  ];

  const specialVehicles = [
    { name: "Toyota Etios", rate: "Rs. 12/km" },
    { name: "Hyundai Creta", rate: "Rs. 13/km" },
    { name: "Tempo Traveller (16 Seater)", rate: "Rs. 26/Km" },
  ];

  const slides = [
    "Experience luxury rides at affordable prices",
    "24/7 reliable taxi service",
    "On-time pickup guaranteed",
    "Professional drivers",
    "Clean & comfortable vehicles",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides.length]);


    const [formData, setFormData] = useState({
    pickup: '',
    destination: '',
    date: '',
    time: ''
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Replace with your WhatsApp number (with country code, remove any +, 0, or spaces)
    const phoneNumber = '919765007100'; // Example: 91 for India, followed by number
    
    // Format the message
    const message = `New Booking Request from wahegurucabs.com website:%0A%0A
      Pickup Location: ${formData.pickup}%0A
      Destination: ${formData.destination}%0A
      Date: ${formData.date}%0A
      Time: ${formData.time}`;
    
    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    
    // Open in new tab
    window.open(whatsappUrl, '_blank');
  };




  return (
    <div>
      <div className="attractive-body">
        {/* 3D Hero Section */}
        <section className="hero-3d">
          {/* Taxi Animation Background */}
          <div className="taxi-animation">
            <div className="city">
              <div className="building"></div>
              <div className="building"></div>
              <div className="building"></div>
              <div className="building"></div>
              <div className="building"></div>
              <div className="building"></div>
            </div>
            <div className="road"></div>
            <div className="taxi">
              <img src={innova} alt="car" />
              {/* <div className="wheel front"></div>
              <div className="wheel rear"></div> */}
            </div>
          </div>

          <div className="text-slider-container">
            <div className="text-slider-track">
              {slides.map((text, index) => (
                <p
                  key={index}
                  className={`slider-text ${
                    index === currentSlide ? "active" : ""
                  }`}
                >
                  {text}
                </p>
              ))}
            </div>
            <div className="slider-dots">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentSlide ? "active" : ""}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
          {/* Interactive Booking Section */}
          <section
            className={`booking-section ${isScrolled ? "elevated" : ""}`}
          >
            <div className="booking-form-container">
              <div className="form-header">
                <h2>Book Your Ride</h2>
                <div className="pulse-dot"></div>
              </div>
    <form className="booking-form" onSubmit={handleSubmit}>
      <div className="input-group floating">
        <input 
          type="text" 
          id="pickup" 
          required 
          value={formData.pickup}
          onChange={handleChange}
        />
        <label htmlFor="pickup">Pickup Location</label>
        <div className="input-icon">📍</div>
      </div>
      <div className="input-group floating">
        <input 
          type="text" 
          id="destination" 
          required 
          value={formData.destination}
          onChange={handleChange}
        />
        <label htmlFor="destination">Destination</label>
        <div className="input-icon">🏁</div>
      </div>
      <div className="input-row">
        <div className="input-group floating">
          <input 
            type="date" 
            id="date" 
            required 
            value={formData.date}
            onChange={handleChange}
          />
          <label htmlFor="date">Date</label>
        </div>
        <div className="input-group floating">
          <input 
            type="time" 
            id="time" 
            required 
            value={formData.time}
            onChange={handleChange}
          />
          <label htmlFor="time">Time</label>
        </div>
      </div>
      <button type="submit" className="submit-button">
        <span>Confirm Booking</span>
        <div className="button-sparkle"></div>
      </button>
    </form>
            </div>
          </section>
        </section>

        <div className="marquee-container">
          <div className="marquee-track">
            <div className="marquee-content">
              {services.map((service, index) => (
                <div key={index} className="marquee-item">
                  <span className="marquee-icon">{service.icon}</span>
                  <span className="marquee-text">{service.text}</span>
                </div>
              ))}
            </div>
            {/* Duplicate for seamless looping */}
            <div className="marquee-content" aria-hidden="true">
              {services.map((service, index) => (
                <div key={`copy-${index}`} className="marquee-item">
                  <span className="marquee-icon">{service.icon}</span>
                  <span className="marquee-text">{service.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Animated taxis */}
          <div className="marquee-taxi left-taxi">
            {/* <div className="taxi">
          <div className="taxi-top"></div>
          <div className="taxi-body">
            <div className="window"></div>
            <div className="light"></div>
            <div className="wheel back-wheel"></div>
            <div className="wheel front-wheel"></div>
          </div>
        </div> */}
          </div>
          <div className="marquee-taxi right-taxi">
            {/* <div className="taxi">
          <div className="taxi-top"></div>
          <div className="taxi-body">
            <div className="window"></div>
            <div className="light"></div>
            <div className="wheel back-wheel"></div>
            <div className="wheel front-wheel"></div>
          </div>
        </div> */}
          </div>
        </div>

        <div className="fare-container">
          <div className="fare-table-container">
            <h2 className="fare-title">Sambhaji Nagar Oneway Taxi Fare</h2>
            <div className="fare-table-one">
              {fareData.map((item, index) => (
                <div
                  key={index}
                  className={`fare-row ${
                    hoveredRow === index ? "hovered" : ""
                  }`}
                  onMouseEnter={() => setHoveredRow(index)}
                  onMouseLeave={() => setHoveredRow(null)}
                >
                  <div className="vehicle-info">
                    <h3 className="vehicle-type">{item.type}</h3>
                    <div className="vehicle-specs">
                      <span className="spec-badge">{item.seats}</span>
                    </div>
                    <div className="km-details">
                      <p>{item.kmIncluded}</p>
                      <p>{item.extraFare}</p>
                    </div>
                  </div>

                  <div className="fare-details">
                    <div className="price-tag">
                      <span className="base-price">{item.baseFare}</span>
                      <span className="total-price">{item.totalFare}</span>
                    </div>
                  </div>

                  <button className="book-button">
                    <Link to="https://wa.me/+919765007100?text=Hi,%20I'm%20interested%20in%20booking%20a%20taxi%20or%20cab.%20Please%20provide%20details." target="_blank"><span>BOOK CAB</span>
                    <div className="button-hover-effect"></div></Link>
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="image-container">
            <img src={homeimage} alt="Taxi service" />
          </div>
        </div>

        <div className="fare-tables-container">
          <h1 className="main-title">Sambhaji Nagar Taxi Fare Sheet</h1>
          <h2 className="subtitle"></h2>

          <div className="tables-grid">
            {/* Fixed Fare Table */}
            <div className="fare-table-wrapper">
              <h3 className="table-title">8Hrs/80km</h3>
              <div className="table-scroll">
                <table className="fare-table">
                  <thead>
                    <tr className="table-header">
                      <th>Car Name</th>
                      <th>Fare</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fareDatatable.map((row, index) => (
                      <tr
                        key={`fixed-${index}`}
                        className={`table-row ${
                          hoveredRow === `fixed-${index}` ? "hovered" : ""
                        }`}
                        onMouseEnter={() =>
                          setHoveredRowtable(`fixed-${index}`)
                        }
                        onMouseLeave={() => setHoveredRowtable(null)}
                      >
                        <td>{row.name}</td>
                        <td className="price-cell">{row.fixed}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Rate 1 Table */}
            <div className="fare-table-wrapper">
              <h3 className="table-title">Outstation</h3>
              <div className="table-scroll">
                <table className="fare-table">
                  <thead>
                    <tr className="table-header">
                      <th>Car Name</th>
                      <th>Fare</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fareDatatable.map((row, index) => (
                      <tr
                        key={`rate1-${index}`}
                        className={`table-row ${
                          hoveredRow === `rate1-${index}` ? "hovered" : ""
                        }`}
                        onMouseEnter={() =>
                          setHoveredRowtable(`rate1-${index}`)
                        }
                        onMouseLeave={() => setHoveredRowtable(null)}
                      >
                        <td>{row.name}</td>
                        <td className="price-cell">{row.rate1}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Rate 2 Table */}
            <div className="fare-table-wrapper">
              <h3 className="table-title">Outstation OneWay</h3>
              <div className="table-scroll">
                <table className="fare-table">
                  <thead>
                    <tr className="table-header">
                      <th>Car Name</th>
                      <th>Fare</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fareDatatable.map((row, index) => (
                      <tr
                        key={`rate2-${index}`}
                        className={`table-row ${
                          hoveredRow === `rate2-${index}` ? "hovered" : ""
                        }`}
                        onMouseEnter={() =>
                          setHoveredRowtable(`rate2-${index}`)
                        }
                        onMouseLeave={() => setHoveredRowtable(null)}
                      >
                        <td>{row.name}</td>
                        <td className="price-cell">{row.rate2}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Special Vehicles Section */}
          <div className="special-vehicles-section">
            <h3 className="special-title">Special Vehicles</h3>
            <div className="special-cards">
              {specialVehicles.map((vehicle, index) => (
                <div
                  key={`special-${index}`}
                  className="special-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <h4>{vehicle.name}</h4>
                  {vehicle.rate && (
                    <div className="special-rate">
                      {vehicle.rate}
                      <div className="pulse-dot"></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Animated Features */}
        <section className="features-section">
          <div className="section-header">
            <h2>Why Choose Us</h2>
            <div className="animated-underline"></div>
          </div>
          <div className="features-container">
            {[
              {
                icon: "⏱️",
                title: "Instant Booking",
                desc: "Get a ride in under 5 minutes",
              },
              {
                icon: "🚙",
                title: "Luxury Fleet",
                desc: "Premium vehicles for every need",
              },
              {
                icon: "💰",
                title: "Best Prices",
                desc: "Competitive rates with no surprises",
              },
              {
                icon: "🛡️",
                title: "Safe Rides",
                desc: "Verified drivers with 5-star ratings",
              },
            ].map((feature, index) => (
              <div
                key={index}
                className={`feature-card ${
                  activeFeature === index ? "active" : ""
                }`}
                onMouseEnter={() => setActiveFeature(index)}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
                <div className="feature-highlight"></div>
              </div>
            ))}
          </div>
        </section>

        <Testimonials />
      </div>
    </div>
  );
};

export default Body;
